var exports = {
  "k": "x31de4314--2badc5--container",
};

module.exports = exports;
